import React, { Component } from "react";
import { connect } from "react-redux";
import ImageList from "./ImageList";
import RaisedButton from "material-ui/RaisedButton";
import FileIcon from "material-ui/svg-icons/file/file-upload";

import Flags from "./Flags";
import { deleteImage, getImages, updateImage, reorderImages } from "./actions";

import "../common.css";
import "./Accomodation.css";

class AccomodationImages extends Component {
  componentDidMount() {}

  deleteImage = code => () => {
    this.props.deleteImage(this.props.merchantCode, code, this.props.lang);
  };

  updateImage = (imageId, title, altText, facet) => {
    this.props.updateImage(
      this.props.merchantCode,
      imageId,
      title,
      altText,
      facet,
      this.props.lang
    );
  };

  reorderImages = images => {
    this.props.reorderImages(this.props.merchantCode, images, this.props.lang);
  };

  renderAccomodationImages = () => {
    const { images } = this.props;
    const tiles = images.map(image => {
      return {
        id: image.id,
        image: image.medium,
        title: image.title,
        alt: image.alt,
        order: image.order,
        facet: image.facet
      };
    });
    return images !== undefined && images.length > 0 ? (
      <div>
        <ImageList
          title={<Flags prevText="Les images " />}
          subtitle="Ajoutez des images représentant l'hébergement dans sa globalité. Les images ajoutées doivent être au format paysage (plus larges que hautes)."
          images={tiles}
          updateCallback={this.updateImage}
          deleteCallback={this.deleteImage}
          reorderCallback={this.reorderImages}
        />
      </div>
    ) : null;
  };

  handleUpload = () => e => {
    setTimeout(() => {
      // Animation purpose
      document.getElementById("uploader").click();
    }, 400);
  };

  progressUpload = () => e => {
    // const percentage = Math.ceil(100 * (e.loaded / e.total))
    // this.props.uploadProgress(percentage)
  };

  progressLoad = xhr => e => {
    // if (xhr.readyState === 4) {
    // const data = JSON.parse(xhr.responseText)
    // this.props.uploadDone(data)
    // }
  };

  handleFileUpload = () => e => {
    const file = e.target.files[0];
    // this.props.addImage(this.props.merchantCode, file)
    const formData = new FormData();
    const code = this.props.merchantCode;
    const lang = this.props.lang;
    formData.append("file", file);
    const xhr = new XMLHttpRequest();
    // xhr.upload.addEventListener('progress', this.progressUpload(), false)
    // xhr.addEventListener('readystatechange', this.progressLoad(xhr), false)
    xhr.open("POST", `/api/merchants/${code}/addImage/${lang}`, true);
    const that = this;
    xhr.onreadystatechange = function() {
      if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
        that.props.getImages(code, lang);
      }
    };
    xhr.send(formData);
  };

  renderProgressBar = () => {
    return true ? (
      <div className="progress-bar">
        <div className="progress" style={{ width: 20 }} />
      </div>
    ) : null;
  };

  renderImageUploader = () => {
    const { images } = this.props;
    const displayMessage = images === undefined || images.length === 0;
    return (
      <div className="card image-uploader">
        <div className="inner">
          {displayMessage ? (
            <div>
              Cet hébergement ne comporte aucune image. Vous pouvez en rajouter
              en cliquant sur le bouton ci-dessous.
            </div>
          ) : (
            <div>
              Ajoutez de nouvelles images pour cet hébergement en cliquant
              ci-dessous.
            </div>
          )}
          <RaisedButton
            className="image-uploader-btn"
            secondary
            label="Ajouter une image"
            icon={<FileIcon />}
            onClick={this.handleUpload()}
          />
          <div className="file-wrapper">
            <input
              type="file"
              id="uploader"
              onChange={this.handleFileUpload()}
            />
          </div>
          {/* {this.renderProgressBar()} */}
        </div>
      </div>
    );
  };

  render() {
    return (
      <div className="accomodation-images">
        <div className="card">{this.renderAccomodationImages()}</div>
        {this.renderImageUploader()}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  merchantCode: state.merchant.detail.code,
  images: state.accomodation.images,
  lang: state.accomodation.lang
});

const mapDispatchToProps = dispatch => ({
  deleteImage: (merchantCode, imageCode, lang) => {
    dispatch(deleteImage(merchantCode, imageCode, lang));
  },
  getImages: (merchantCode, lang) => {
    dispatch(getImages(merchantCode, lang));
  },
  updateImage: (merchantCode, imageId, title, altText, facet, lang) => {
    dispatch(updateImage(merchantCode, imageId, title, altText, facet, lang));
  },
  reorderImages: (merchantCode, images, lang) => {
    dispatch(reorderImages(merchantCode, images, lang));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AccomodationImages);



// WEBPACK FOOTER //
// ./src/merchant/accomodation/AccomodationImages.js